import { useQuery } from '@tanstack/react-query';
import { getExamResult } from '@/api/applicant';
import { appKeys, useStatus } from '../shared';
import { Actions, Body, Hero, Loading, Panel, Pill, Primary, Rows, Screen } from '../ui';

export function ResultPage() {
  const q = useQuery({ queryKey: appKeys.result, queryFn: getExamResult, retry: false });
  const status = useStatus();
  const r = q.data;
  const name = status.data?.name;
  const graded = r && r.score !== null && r.percentage !== null;

  if (q.isLoading) return <Screen><Hero title="Entrance exam result" /><Loading /></Screen>;

  return (
    <Screen>
      <Hero title="Entrance exam result" sub={name ?? r?.exam_name ?? undefined} />
      <Body>
        {!r ? (
          <Panel><p className="text-slate-600">No entrance exam has been booked for you yet. You will be told when it is.</p></Panel>
        ) : graded ? (
          <>
            <Panel className="text-center">
              <p className="text-slate-500">Your score</p>
              <p className={`text-6xl font-extrabold mt-1 ${r.passed ? 'text-[#1B5E20]' : 'text-red-600'}`}>{Math.round(r.percentage!)}%</p>
              <div className="mt-2">{r.passed ? <Pill tone="green">Passed</Pill> : <Pill tone="red">Below pass mark ({r.pass_mark}%)</Pill>}</div>
            </Panel>
            {!!r.subjects?.length && <Panel><Rows rows={r.subjects.map((s) => [s.name ?? 'Subject', Math.round(s.percentage)])} /></Panel>}
            <p className="text-center text-sm text-slate-500">
              {status.data?.admission ? 'You have been admitted. See your reg number on the home screen.' : status.data?.decision ? 'The school has made its decision.' : 'The school will tell you its decision soon.'}
            </p>
          </>
        ) : (
          <Panel><p className="text-slate-600">{r.status === 'scheduled' ? 'You have not taken the entrance exam yet.' : r.status === 'absent' ? 'You were marked absent. Please contact the school.' : 'Your exam is being marked. Check back soon.'}</p></Panel>
        )}
        <Actions>
          {r?.status === 'scheduled' ? <Primary to="/applicant/exam">Go to entrance exam</Primary> : <Primary to="/applicant/overview">Back to tracker</Primary>}
        </Actions>
      </Body>
    </Screen>
  );
}
